import { createSlice } from "@reduxjs/toolkit";

const user = {
  ok: true,
  data: {
    user: {
      id: 3,
      full_name: "Quvondiq Ortiqov",
      phone_number: "+998901234567",
      role: 3,
      telegram_id: "1598016165",
      step: "menu",
      adstep: "menu",
      created_at: "2022-06-21T10:28:52.401Z",
      updated_at: "2022-06-21T10:30:14.545Z",
      mosque_admin: {
        id: 1,
        user_id: 3,
        mosque_id: 2,
        created_at: "2022-06-21T10:30:14.259Z",
        updated_at: "2022-06-21T10:30:14.259Z",
      },
    },
  },
};

const initialState = { currentUser: user };

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setCurrentUser: (state, action) => {
      return { ...state, currentUser: action.payload };
    },
  },
});

export const { setCurrentUser } = userSlice.actions;

export default userSlice.reducer;
